<div class="mvd_container mvd_container--pdf" [ngClass]="{hidden: !showSearch || showAdd}">
    <header *ngIf="showHeader" class="header--well hide--modal">
        <ul>
            <li class="header__title">
                <h2>Customer Search</h2>
            </li>
        </ul>
    </header>

    <div class="well">
        <div class="search__customer-type" [ngClass]="{ 'block': !showSearchCriteriaCheckboxes }" *ngIf="showCustomerType">
            <label>Customer Type</label>
            <select class="search__customer-type__select" [(ngModel)]="customerTypeId" (change)="customerTypeChange($event.target.value)">
                <option [value]="INDIVIDUAL_TYPE">Individual</option>
                <option [value]="ORGANIZATION_TYPE">Organization</option>
            </select>
        </div>
        <individual-search
            *ngIf="showIndividual"
            (onAddCustomerClicked)="addCustomer($event)"
            (onResultsReceived)="resultsReceived($event)" (onFormReset)="reset()"
            [data]="data" [searchInfo]="searchInfo" [showSearchCriteria]="showSearchCriteria" [defaultCustomerIdentificationTypeId]="defaultCustomerIdentificationTypeId"
            [showSearchCriteriaCheckboxes]="showSearchCriteriaCheckboxes" [showResults]="showResults" [includeDeceased]="includeDeceased" [maskSSN]="maskSSN">
        </individual-search>
        <organization-search
            *ngIf="!showIndividual"
            (onAddCustomerClicked)="addCustomer($event)"
            (onResultsReceived)="resultsReceived($event)" (onFormReset)="reset()"
            [data]="data" [searchInfo]="searchInfo"  [showSearchCriteria]="showSearchCriteria"
            [showResults]="showResults">
        </organization-search>
        <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
        <customer-search-results
            *ngIf="showResults"
            (onCustomerSelected)="customerSelected($event)"
            (onCustomerNameClicked)="customerNameClicked($event)"
            [data]="data" [showSelect]="true" [enableAutoSelect]="enableAutoSelect">
        </customer-search-results>
    </div>
</div>

<add-customer
    *ngIf="showAdd && !showSearch"
    [customerTypeId]="customerTypeId" [searchInfo]="searchInfo" [address]="address" [showHeader]="showHeader" 
    [showButtonLoading]="showButtonLoading" [maskSSN]="maskSSN" [showCustomerType]="showCustomerType"
    [isOverrideIndividualFormSubmit]="isOverrideIndividualFormSubmit"
    (onIndividualFormSubmit)="customerCreateSubmit($event)"
    (onIndividualCustomerAdded)="customerCreated($event)"
    (onOrganizationCustomerAdded)="customerCreated($event)"
    (onCustomerCancel)="customerAddCancel()">
</add-customer>
